import CopyTextToClipboard from '@components/CopyTextToClipboard';
import { Text, TextColor, TextSize, TextWeight } from '@components/Text';

interface TrackingNumberProps {
  trackNumber?: string;
  externalId?: string;
  onClick?: () => void;
  allowEqualNumbers?: boolean;
  ignoreClickSecond?: boolean;
}

const TrackingNumber = ({
  trackNumber,
  externalId,
  onClick,
  allowEqualNumbers,
  ignoreClickSecond = false
}: TrackingNumberProps) => {
  return (
    <>
      <CopyTextToClipboard
        text={trackNumber ?? ""}
        visibleOnHover
      >
        <span
          onClick={(e: React.MouseEvent<HTMLSpanElement>) => {
            e.stopPropagation();
            onClick && onClick();
          }}
        >
          <Text
            color={TextColor.PRIMARY}
            onHoverColor={onClick ? TextColor.BLUE : TextColor.PRIMARY}
            size={TextSize.S}
            weight={TextWeight.BOLD}
          >
            {trackNumber}
          </Text>
        </span>
      </CopyTextToClipboard>
      {(externalId && ((externalId !== trackNumber) || allowEqualNumbers)) ? (
        <CopyTextToClipboard
          text={externalId}
          visibleOnHover
        >
          <span
            onClick={(e: React.MouseEvent<HTMLSpanElement>) => {
              e.stopPropagation();
              !ignoreClickSecond && onClick && onClick();
            }}
          >
            <Text
              color={TextColor.DARK_MUTED}
              size={TextSize.XS}
            >
              {externalId}
            </Text>
          </span>
        </CopyTextToClipboard>
      ) : null}
    </>
  );
};

export default TrackingNumber;
